import BaseAPIService from 'src/services/base/base-api-service';
import AccountClass from 'src/model/account.model';

class AccountService extends BaseAPIService<AccountClass> {
  public accountsEndpoint: string = '/accountapp/v1/accounts/';
  constructor() {
    super(AccountClass);
  }

  public getUserAccounts(): Promise<AccountClass[]> {
    return this.getAll(this.accountsEndpoint);
  }

  public searchUsers = (
    search: string,
    page?: number,
    size?: number
  ): Promise<AccountClass[]> => {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      params: {
        search,
        page,
        size
      },
      url: `${this.accountsEndpoint}search`
    })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        throw error;
      });
  };

  public getDeliveryStatus = (): Promise<{
    accountId: string;
    deliverCompleteFlag: boolean;
  }> => {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      url: `${this.accountsEndpoint}deliverComplete`
    })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        throw error;
      });
  };

  public getCreditCardFlagStatus(): Promise<boolean> {
    return this.doRequest({
      baseURL: this.baseURL,
      method: 'GET',
      url: `${this.accountsEndpoint}isCreditCardAuthorized`
    })
      .then(res => {
        return res.data;
      })
      .catch(error => {
        throw error;
      });
  }
}

const accountServiceInstance = new AccountService();
Object.freeze(accountServiceInstance);

export default accountServiceInstance;
